import axios from "axios";
import { useJtwStore } from "../store/jwt_token/jwt_token";
import baseURL from "@/utilities/constantes";
//import Utils from "@/utils/Utils";

const axiosInstance = axios.create({
  baseURL: baseURL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    "Access-Control-Allow-Origin": "*",
  },
});
axiosInstance.interceptors.request.use(
  function (config) {
    const token = useJtwStore();
    if (token.token) {
      config.headers.common["Authorization"] = `Bearer ${token.token}`;

      /*       config.headers.common[
        "Content-Type"
      ] = `application/x-www-form-urlencoded`; */
    }
    /* 
    config.headers.common["Content-Type"] = "application/x-www-form-urlencoded";     */
    /*  config.headers.common["access-control-allow-origin"] = "*"; */
    /*   config.headers.common["Content-Type"] = "application/json; charset=utf-8"; */
    /*  config.headers.common["Content-Type"] = "application/application/json; charset=utf-8 "; */
    /*   config.headers.common["access-control-allow-headers"] = "Authorization,"; */ /* 
    config.headers.common["access-control-allow-methods"] = "GET, PUT, POST, PATCH,DELETE"; */
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  function (response) {
    /* if (!response.data.success && response.data.error == "Access denied.") {
      const util = new Utils();
      util.handleLogout();
    } */
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default axiosInstance;
